import { AuditFields } from '@src/main/shared/domain/audit-fields.interface';
import { formatDateTime } from '@src/main/shared/utils/dateUtils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AppStatusIncidents.module.scss';

type AppStatusAuditInfoProps = {
  auditFields: AuditFields;
};

const AppStatusAuditInfo: FC<AppStatusAuditInfoProps> = ({ auditFields }) => {
  const { t } = useTranslation();
  const createdAt = formatDateTime(auditFields.createdAt ?? undefined);
  const updatedAt = formatDateTime(auditFields.updatedAt ?? undefined);

  const items = [
    {
      icon: 'pi-user-plus',
      label: t('appStatus.audit.createdBy'),
      value: auditFields.createdBy || t('appStatus.audit.notAvailable'),
    },
    {
      icon: 'pi-calendar-plus',
      label: t('appStatus.audit.createdAt'),
      value: createdAt || t('appStatus.audit.notAvailable'),
    },
    {
      icon: 'pi-user-edit',
      label: t('appStatus.audit.updatedBy'),
      value: auditFields.updatedBy || t('appStatus.audit.notUpdated'),
    },
    {
      icon: 'pi-calendar-clock',
      label: t('appStatus.audit.updatedAt'),
      value: updatedAt || t('appStatus.audit.notUpdated'),
    },
  ];

  return (
    <section className={styles['audit-section']} aria-labelledby="app-status-audit-title">
      <div className={styles['audit-heading']}>
        <i className="pi pi-history" aria-hidden="true" />
        <h3 id="app-status-audit-title">{t('appStatus.audit.title')}</h3>
      </div>
      <dl className={styles['audit-grid']}>
        {items.map((item) => (
          <div className={styles['audit-item']} key={item.label}>
            <span className={styles['audit-icon']} aria-hidden="true">
              <i className={`pi ${item.icon}`} />
            </span>
            <div className={styles['audit-content']}>
              <dt>{item.label}</dt>
              <dd title={item.value}>{item.value}</dd>
            </div>
          </div>
        ))}
      </dl>
    </section>
  );
};

export default AppStatusAuditInfo;
